<template>
  <!-- 头部整体盒子 -->
  <div id="header" :class="['container-fuild', isNavFixed ? 'is-nav-fixed' : '', isNavDown ? 'is-nav-down' : '']">
    <!-- 电脑导航 -->
    <div class="header-nav">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/logo_white.png" />
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
          @click="navClick(index, item.name)">
          <template v-if="item.path == '/joinus'">
            <a href="https://izhaopin.peets.cn/#/" target="_blank">{{item.name}}</a>
          </template>
          <template v-else-if="item.path == '/service'">
            <a href="https://mp.weixin.qq.com/s/ETfUftrHKAPklHw2s3BC0A" target="_blank">{{item.name}}</a>
          </template>
          <template v-else>
            <router-link :to="item.path">
              {{ item.name }}
            </router-link>
          </template>

          <!-- <dl v-if="item.children.length > 0">
            <dt v-for="(i, n) in item.children" :key="n">
              <router-link :to="i.path">{{ i.name }}</router-link>
            </dt>
          </dl> -->
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      i: 0,
      isNavFixed: false,
      isNavDown: false,
      nMenvRight: "-100%",
      // navIndex: sessionStorage.getItem("navIndex")
      //   ? sessionStorage.getItem("navIndex")
      //   : 0,
      //navIndex: 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "/",
          children: [],
        },
        {
          name: "我们的品牌",
          path: "/brand",
          children: [],
        },
        {
          name: "我们的产品",
          path: "/product",
          children: [],
        },
        {
          name: "我们的门店",
          path: "/store",
          children: [],
        },
        {
          name: "专业咖啡服务",
          path: "/service",
          children: [],
        },
        {
          name: "咖啡学院",
          path: "/college",
          children: [],
        },
        {
          name: "加入我们",
          path: "/joinus",
          children: [],
        },
      ],
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true);
  },

  watch: {
    $route(to, from) {
      if (to != from) {
        this.nMenvRight = "-100%";
      }
    },
    immediate: true
  },

  computed: {
    navIndex() {
      //console.log(this.$route.path)
      let that = this,
        _idx;
      if (that.$route.path === '/news/newsdetail') {
        _idx = 0;
      } else {
        _idx = that.navList.findIndex((item) => (item.path === that.$route.path));
      }
      return _idx
    }
  },

  methods: {
    handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
        document.body.scrollTop
      var scroll = scrollTop - this.i;
      this.i = scrollTop;
      if (scroll > 0) {
        this.isNavFixed = true;
      }
      if (this.i == 0) {
        this.isNavFixed = false;
      }
      // if (scroll < 0) {
      //   this.isNavFixed = true;
      //   this.isNavDown = false;
      // } else {
      //   this.isNavFixed = false;
      //   this.isNavDown = true;
      // }
      // if (this.i == 0) {
      //   this.isNavFixed = false;
      //   this.isNavDown = false;
      // }

    },
    navClick(index, name) {
      //this.navIndex = index;
      //sessionStorage.setItem("navIndex", index);
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    nMenuClick() {
      if (this.nMenvRight == "-100%") {
        this.nMenvRight = "0";
      } else {
        this.nMenvRight = "-100%";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
a {
  &:focus {
    text-decoration: none;
  }

  &:hover {
    text-decoration: none;
  }
}

/* 顶部 */
#header {
  width: 100%;
  height: 90px;
  background: #8e713c;
  transition: all 1s;
  // position: absolute;
  // left: 0;
  // top: 0;
  z-index: 10;

  &.is-nav-fixed {
    position: fixed;
    z-index: 1001;
    background: rgba(142, 113, 60, .9);
    box-shadow: 0 1px 10px 0 rgb(90 43 129 / 20%);
  }

  &.is-nav-down {
    top: -100%;
  }

  .header-nav {
    max-width: 1440px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &::before {
      display: none;
    }

    &::after {
      display: none;
    }

    .header-nav-logo {
      display: flex;

      img {
        max-width: 227px;
      }
    }

    .header-nav-wrapper {
      margin: 0;
      display: flex;
      font-size: 14px;
      color: #fff;

      li {
        margin-left: 30px;

        a {
          color: #fff;
          padding: 0 30px 17px 30px;

          &:hover {
            color: #fff;
            text-decoration: none;
          }
        }

        &.active {
          a {
            color: #fff;
            border-bottom: 2px solid #fff;

            &:hover {
              text-decoration: none;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 997px) {
  // #header {
  //   background: none;
  //   height: 80px;
  // }

  // .header-nav-m {
  //   background: #fff;
  //   height: 80px;
  //   width: 100%;
  //   position: absolute;
  //   left: 0;
  //   top: 0;
  //   transition: all 0.5s;
  //   box-shadow: 0 1px 10px 0 rgb(90 43 129 / 20%);

  //   .header-nav-m-ct {
  //     width: 100%;
  //     height: 100%;
  //     display: flex;
  //     align-items: center;
  //     justify-content: space-between;

  //     .header-nav-m-logo {
  //       margin-left: 15px;

  //       img {
  //         max-width: 85px;
  //       }
  //     }

  //     .header-nav-m-icon {
  //       width: 32px;
  //       margin-right: 15px;

  //       img {
  //         width: 32px;
  //       }
  //     }
  //   }
  // }

  // .menu-expanded {
  //   overflow-y: auto;
  //   display: block;
  //   height: 100vh;
  //   width: 100%;
  //   padding: 24px;
  //   position: fixed;
  //   top: 0;
  //   z-index: 1650;
  //   background: #fff;
  //   transition: all 0.15s cubic-bezier(0.455, 0.03, 0.515, 0.955);
  //   box-shadow: 0 2px 6px 2px hsl(194deg 8% 50% / 22%);

  //   .m-ex-top {
  //     display: flex;
  //     align-items: center;
  //     justify-content: space-between;
  //     margin-bottom: 36px;

  //     .m-ex-logo {
  //       img {
  //         max-width: 85px;
  //       }
  //     }

  //     .m-ex-close {
  //       img {
  //         max-width: 20px;
  //       }
  //     }
  //   }

  //   .m-ex-el-nav {
  //     list-style: none;
  //     position: relative;
  //     margin: 0;
  //     padding-left: 0;
  //     background-color: #fff;

  //     .m-ex-menu-item {
  //       border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  //       height: 60px;
  //       line-height: 60px;
  //       display: flex;
  //       -webkit-box-align: center;
  //       -ms-flex-align: center;
  //       align-items: center;
  //       -webkit-box-pack: center;
  //       -ms-flex-pack: center;
  //       justify-content: center;
  //       letter-spacing: 0.4px;

  //       a {
  //         font-size: 14px;
  //         line-height: 18px;
  //         color: #272727;

  //         span {
  //           font-family: $FM6;
  //         }
  //       }
  //     }
  //   }
  // }
}

@media screen and (min-width: 768px) and (max-width: 996px) {
  #header {
    height: 120px;

    .header-nav {
      padding-left: 15px;
      padding-right: 15px;

      .header-nav-wrapper {
        li {
          margin-left: 0;

          a {}
        }
      }
    }
  }
}

@media screen and (min-width: 997px) and (max-width: 1199px) {
  #header {
    height: 110px;

    .header-nav {
      padding-left: 15px;
      padding-right: 15px;

      .header-nav-wrapper {

        li {
          margin-left: 0;
        }
      }
    }
  }
}


@media screen and (min-width: 1200px) {
  #header {}
}

@media screen and (min-width: 1440px) {
  #header {}
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue